import { createAction, props } from "@ngrx/store";
import { Language } from "../../models/application.model";
import { RefreshTokenRequest, RefreshTokenResponse, User, UserAttributes, UserLoginRequest } from "../../models/user.model";


export const languageChangeRequest = createAction(
    '[Setting] Language change request', props<{ newLanguage: Language }>());

export const languageChangeSuccess = createAction(
    '[Setting] Language changed successfully');

export const loadingStart = createAction(
    '[Setting] Loading start');

export const loadingStop = createAction(
    '[Setting] Loading stop');

export const loginRequest = createAction(
    '[Login] User login request', props<{ userLogin?: UserLoginRequest }>());

export const loginSuccess = createAction(
    '[Login] User login success', props<{ loggedUser: User }>());

export const loginFail = createAction(
    '[Login] User login fail');

export const logout = createAction(
    '[Logout] User logged out');

export const passwordChangeRequest = createAction(
    '[Setting] Password change request', props<{ oldPassword: string, newPassword: string }>());

export const passwordChangeSuccess = createAction(
    '[Setting] Password change success');

export const passwordChangeFail = createAction(
    '[Setting] Password change fail');

export const refreshTokenRequest = createAction(
    '[Login] User refresh token request', props<{ refreshTokenRequest: RefreshTokenRequest }>());

export const takeCurrentSessionRequest = createAction(
    '[Login] User takes current session request');

export const takeCurrentSessionFail = createAction(
    '[Login] User takes current session fail');

export const takeCurrentSessionSuccess = createAction(
    '[Login] User takes current session successfully', props<{
        userAttributes: UserAttributes,
        refreshToken: string, refreshTokenResponse: RefreshTokenResponse
    }>());
